import BasketClaimsSFC from "./BasketClaims.vue";
export const BasketClaims = BasketClaimsSFC;
